import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Check, HeartHandshake, Users } from 'lucide-react';
export function Coalition() {
  const sectors = [{
    label: 'Public',
    description: 'Local leaders accountable to residents.',
    icon: Users
  }, {
    label: 'Private',
    description: 'Employers and entrepreneurs invested in strong neighborhoods.',
    icon: Briefcase
  }, {
    label: 'Nonprofit',
    description: 'Community advocates who help neighbors flourish.',
    icon: HeartHandshake
  }];
  const pledge = [{
    action: 'Listen',
    description: 'to Arizona communities before acting on their behalf.'
  }, {
    action: 'Collaborate',
    description: 'across sectors to advance practical local needs.'
  }, {
    action: 'Protect',
    description: 'the tools communities use to shape responsible growth.'
  }, {
    action: 'Defend',
    description: 'residents from government overreach at every level.'
  }];
  return <section id="coalition" className="py-24 bg-pac-sand scroll-mt-24" data-id="element-22" data-mp="7s13zw08bf8j">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23" data-mp="co8dtzvqxavr">
        <div className="text-center mb-16" data-id="element-24" data-mp="3u5suz55rg2zt">
          <p className="text-pac-red font-bold uppercase tracking-[0.2em] text-sm mb-3" data-id="element-25" data-mp="3u4zo846sxdho">
            Stronger Together
          </p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-4" data-id="element-26" data-mp="3l4l3b5xr20ep">
            A Coalition as Broad as Arizona
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-27" data-mp="3q4fqayeem5uh">
            We unite leaders who believe Arizona&apos;s next chapter should be
            shaped with communities — not imposed on them.
          </p>
          <div className="w-24 h-1 bg-pac-red mx-auto mt-6" data-id="element-28" data-mp="3g5qixzk4w3sh" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-29" data-mp="19gbw4swh82mj">
          {sectors.map((sector, index) => <motion.article key={sector.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl border border-slate-200 shadow-sm text-center" data-id="element-30" data-mp="1edc3d752bbf8" data-mpi={index}>
              <div className="w-14 h-14 bg-pac-navy rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-31" data-mp="yy8couidfwkr">
                <sector.icon className="h-7 w-7 text-pac-gold" data-id="element-32" data-mp="1vmxvqo5qiv8b" />
              </div>
              <h3 className="font-serif text-2xl font-bold text-pac-navy mb-3" data-id="element-33" data-mp="1qpe84xn5d63p">
                {sector.label}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-34" data-mp="1lvtjhw7g1oh6">
                {sector.description}
              </p>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden max-w-4xl mx-auto" data-id="element-35" data-mp="2eez0261a3dp4">
          <div className="bg-pac-navy px-8 py-8 md:px-12 text-center" data-id="element-36" data-mp="14gvoijmqj2a">
            <h3 className="font-serif text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-37" data-mp="54rb0ltbaltt">
              The Local Voices Pledge
            </h3>
            <p className="text-pac-gold font-bold uppercase tracking-wider text-sm" data-id="element-38" data-mp="a5ne4x5ua3y6">
              We support leaders who will…
            </p>
          </div>
          <ul className="p-8 md:p-12 space-y-6" data-id="element-39" data-mp="k1qepyl1luj0">
            {pledge.map(item => <li key={item.action} className="flex items-start gap-4" data-id="element-40" data-mp="oti445sgpu7k">
                <span className="shrink-0 w-8 h-8 rounded-full bg-pac-gold/15 flex items-center justify-center mt-0.5" data-id="element-41" data-mp="ovm9ks60f19y">
                  <Check className="h-5 w-5 text-pac-gold" data-id="element-42" data-mp="xu6nlg0mkmru" />
                </span>
                <p className="text-lg md:text-xl text-slate-700 leading-relaxed" data-id="element-43" data-mp="xs3p07leplbi">
                  <span className="font-bold text-pac-navy uppercase tracking-wider" data-id="element-44" data-mp="12qx1pxsvd8am">
                    {item.action}
                  </span>{' '}
                  {item.description}
                </p>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}